<template>
  <el-dialog
    title="导入快递单号"
    :visible.sync="isShow"
    width="1000px"
    destroy-on-close
    @close="closeDoalog"
  >
    <el-button type="text" size="medium" @click="downloadTemplate">
      下载导入模板
    </el-button>

    <div class="upload-wrap">
      <span>选择文件并上传：</span>
      <el-upload
        action=""
        multiple
        :show-file-list="false"
        :http-request="uploadExpressBll"
        style="display: inline-block;margin: 0 10px 0 0"
      >
        <el-button :loading="isUploadLoading" type="primary">
          上传
        </el-button>
      </el-upload>
    </div>

    <el-table :data="errorList" border height="300">
      <el-table-column label="错误信息">
        <el-table-column
          prop="line"
          label="行号"
        />
        <el-table-column
          prop="failMsg"
          label="错误提示"
        />
      </el-table-column>
    </el-table>

    <el-table :data="tableData" border height="300" style="margin-top: 20px;">
      <el-table-column type="index" label="序号" align="left" />
      <el-table-column prop="operationCenter" label="营运中心" align="left" />
      <el-table-column prop="kpOrderUnit" label="开票客户名称" align="left" />
      <el-table-column prop="invoiceNo" label="金税发票号" align="left" />
      <el-table-column prop="approvalNumber" label="开票通知单号" align="left" />
      <el-table-column prop="logisticsNo" label="快递单号" align="left" />
    </el-table>

    <div slot="footer">
      <el-button type="default" @click="closeDoalog">
        取消导入
      </el-button>
      <el-button type="primary" :disabled="errorList.length !== 0" :loading="isSubmitLoading" @click="submitImport">
        确定导入
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { importExpressBllCheck, importExpressBll } from '@/API';
import { downloadUrlFile } from '@/libs/util';
export default {
  data () {
    return {
      isShow: false,
      isUploadLoading: false,
      errorList: [],
      tableData: [],
      isSubmitLoading: false
    };
  },

  methods: {
    openDialog () {
      this.isShow = true;
    },

    closeDoalog () {
      this.errorList = [];
      this.tableData = [];
      this.isShow = false;
      this.$emit('init-data');
    },

    downloadTemplate () {
      downloadUrlFile('/导入快递单号模板.xlsx');
    },

    uploadExpressBll (upload) {
      this.isUploadLoading = true;
      let formDate = new FormData();
      formDate.append('file', upload.file);

      importExpressBllCheck(formDate)
        .then(res => {
          this.isUploadLoading = false;
          let { status, data } = res.data;
          if (status === '200') {
            this.errorList = data.errorList;
            this.tableData = data.expressBllExcelList;
          }
        })
        .catch(() => {
          this.isUploadLoading = false;
        });
    },

    submitImport () {
      this.isSubmitLoading = true;
      let params = {
        expressBllExcelList: this.tableData
      };

      importExpressBll(params)
        .then(res => {
          this.isSubmitLoading = false;
          let { status } = res.data;
          if (status === '200') {
            this.$message.success('上传成功');
            this.closeDoalog();
          }
        }).catch(() => {
          this.isSubmitLoading = false;
        });
    }

  }
};
</script>

<style scoped>
.upload-wrap{
  margin: 10px 0 20px;
}
</style>
